// extracted by mini-css-extract-plugin
module.exports = {"addContainer":"add_addContainer__FV8yl","iconContainer":"add_iconContainer__3_5l1","textContainer":"add_textContainer__3Qb_M"};